var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"common-checkout",on:{"click":_vm.handClick}},[(_vm.value)?_c('svg',{staticClass:"icon icon-16",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-c_15_1"}})]):_c('svg',{staticClass:"icon icon-16",attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":"#icon-c_15"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }